<template>
  <button type="button" class="mbtn btn-info exportbtn">
    <span class="far fa-file-excel"></span>
    {{ btnvalue }}
  </button>
</template>

<script>
export default {
  props: {
    btnvalue: {
      type: String,
      default: "Export", // Keep default redirect behavior for all existing usages
    },
  },
};
</script>

<style scoped>
.far {
  font-size: 13px;
}
</style>
